import { CellFormatOptions, ColumnTable, Icon } from '@octano/global-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'reactstrap';

interface Props {
  remove: (index: number) => void;
  readOnly: boolean;
}

export function useColumns({ remove, readOnly }: Props): ColumnTable[] {
  const { t } = useTranslation();
  const prefix = 'studyPlans.curriculum.degreeDocuments.table.headers';

  return useMemo(
    () => [
      {
        columnName: 'name',
        headerText: t(`${prefix}.name`),
        tdClassName: 'text-center',
        thClassName: 'text-center',
      },
      {
        columnName: 'code',
        headerText: t(`${prefix}.code`),
        tdClassName: 'text-center',
        thClassName: 'text-center',
      },
      {
        columnName: 'description',
        headerText: t(`${prefix}.description`),
        tdClassName: 'text-center',
        thClassName: 'text-center',
      },
      {
        columnName: 'action',
        headerText: t(`${prefix}.action`),
        tdClassName: 'text-center',
        thClassName: 'text-center',
        cellFormat: (data: CellFormatOptions<any>) => {
          return (
            <Button
              type="button"
              className="bg-transparent border-0"
              onClick={() => remove(data.index)}
              disabled={readOnly}
            >
              <Icon
                size="15"
                name="trash"
                color={readOnly ? 'disabled' : 'primary'}
              />
            </Button>
          );
        },
      },
    ],
    [t, remove, readOnly],
  );
}
